export default class Chart {
    constructor() {
        this._ = [];
    }

    setData(d) {
        this._ = d;
    }
}